import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  DRAWINGS_REPORT_GET_JOB_LIST: createSagaAction('DRAWINGS_REPORT_GET_JOB_LIST'),
  DRAWINGS_REPORT_GET_ORGANIZATION_LIST: createSagaAction('DRAWINGS_REPORT_GET_ORGANIZATION_LIST'),
  DRAWINGS_REPORT_GET_FULL_REPORT: createSagaAction('DRAWINGS_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  drawingsReportGetJobList: ({ filters }) => ({
    type: constants.DRAWINGS_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  drawingsReportGetOrganizationList: ({ filters }) => ({
    type: constants.DRAWINGS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    filters
  }),
  drawingsReportGetFullReport: ({ filters }) => ({
    type: constants.DRAWINGS_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.DRAWINGS_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.DRAWINGS_REPORT_GET_JOB_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingJobList: false,
        jobList: action.payload
      }

    case constants.DRAWINGS_REPORT_GET_ORGANIZATION_LIST.ACTION:
      return { ...state, error: null, loadingOrganizationList: true }
    case constants.DRAWINGS_REPORT_GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingOrganizationList: false,
        organizationList: action.payload
      }

    case constants.DRAWINGS_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.DRAWINGS_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/jobs/drawingsReportActions.js